module.exports = __webpack_public_path__ + "static/img/myCourses_img.8209bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personal/myCourses_img.png
// module id = Z9NJ
// module chunks = 23